import { Paper, Box, Typography, styled } from "@mui/material"

import Button from "components/ui/Submit"

export const Card = styled(Paper)(({ theme }) => ({
  borderRadius: "17px",
  marginBottom: "38px",
  [theme.breakpoints.up("sm")]: {
    padding: "41px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0px",
  },
}))

export const Headline = styled(Typography)(({ theme }) => ({
  fontSize: "1.125rem",
  fontWeight: "500",
  marginBottom: "41px",
  [theme.breakpoints.up("sm")]: {},
}))

export const Terms = styled(Box)(({ theme }) => ({
  display: "none",
  marginBottom: "15px",
  padding: "0 41px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "5px",
    padding: "0 10px",
  },
}))

export const Submit = styled(Button)(({ theme }) => ({
  borderRadius: "15px",
  display: "block",
  margin: "0 auto",
  width: "100%",
  [theme.breakpoints.up("sm")]: {},
}))
